import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import ImpressumPage from './pages/ImpressumPage';

function App() {
  useEffect(() => {
    document.title = 'Sijelly IT GmbH — IT-Consulting & Testmanagement';
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profil/:id" element={<Profile />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/impressum" element={<ImpressumPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          © {new Date().getFullYear()} Sijelly IT GmbH · Bremen ·{' '}
          <a href="#/impressum">Impressum & Datenschutz</a>
        </p>
      </div>
    </footer>
  );
}

export default App;
